import './style.scss';

const CenteredContainer = (props) => {
  return (
    <div className='centered-container'>
      <div className='contents'>
        { props.children }
      </div>
    </div>
  );
};

export default CenteredContainer;
